import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPauseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 39.428 43",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "a",
		x: 0,
		y: 0,
		width: 39.428,
		height: 43,
		filterUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
			/* @__PURE__ */ _jsx("feComposite", {
				operator: "in",
				in2: "b"
			}),
			/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
		]
	}) }), /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1, 0, 0, 1, 0, 0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M856.1,29V4h7.143V29ZM870.386,4h7.143V29h-7.143Z",
			transform: "translate(-847.1 2)"
		})
	})]
});
export default SvgPauseIcon;
